import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
import { decodeJwt } from 'jose'

import {
  apiSlice,
  useLoginMutation,
  useLazyAutoLoginQuery,
  useLazyImpersonateQuery,
} from './api-slice'
import { useFeedback } from './feedback-hook'
import { resetSelection } from '../container/selection'
import { resetHome, setInfoUtente } from '../container/home'

export const useAuth = () => {
  const [loginMutation] = useLoginMutation()
  const [autoLoginQuery] = useLazyAutoLoginQuery()
  const [triggerImpersonate] = useLazyImpersonateQuery()

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { setFeedback } = useFeedback()

  const login = useCallback(
    async ({
      codice,
      password,
      token,
      impersonateUser,
      triggerFunction = () => {},
    }) => {
      try {
        let data
        if (impersonateUser) {
          data = await triggerImpersonate(impersonateUser).unwrap()
        } else if (token) {
          data = await autoLoginQuery(token).unwrap()
        } else {
          data = await loginMutation({ codice, password }).unwrap()
        }

        const authToken = data?.token
        if (!authToken) throw new Error('Login fallito.')

        if (impersonateUser)
          localStorage.setItem('tokenImp', localStorage.getItem('token'))

        localStorage.setItem('token', JSON.stringify(authToken))

        const payload = decodeJwt(authToken)

        dispatch(
          setInfoUtente({
            auth: true,
            admin: !!payload.admin,
            societa: !!payload.societa,
            arbitro: !!payload.arbitro,
            designatore: !!payload.designatore,
            omologatore: !!payload.omologatore,
            codiceUtente: payload.codiceUtente,
            idArbitro: payload.idArbitro,
            token: authToken,
            tokenExp: payload.exp * 1000,
            impersonation: payload.sub === 'impersonate',
          }),
        )

        triggerFunction()
      } catch (err) {
        localStorage.removeItem('token')
        setFeedback(err?.data?.message || err?.message)
      }
    },
    [autoLoginQuery, dispatch, loginMutation, setFeedback, triggerImpersonate],
  )

  const logout = useCallback(
    impersonation => {
      const tokenImp = JSON.parse(localStorage.getItem('tokenImp'))

      localStorage.clear()

      dispatch(resetHome())
      if (!impersonation) dispatch(resetSelection())
      dispatch(apiSlice.util.resetApiState())

      if (!impersonation) navigate('/')

      if (tokenImp) login({ token: tokenImp })
    },
    [dispatch, login, navigate],
  )

  return { login, logout }
}
